import React, {useContext, useEffect, useState} from 'react';
import logo from "../../accets/img/Logo.png";
import {useNavigate} from "react-router-dom";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import {fetchUsers} from "../../http/UserAPI";
import ModalRegistration from "../Modal/ModalRegistration";

const Registration = () => {

    const navigate = useNavigate()

    const {userStore} = useContext(Context)

    const [nickname, setNickname] = useState('')
    const [password, setPassword] = useState('')
    const [firstName, setFirstName] = useState('')
    const [secondName, setSecondName] = useState('')
    const [allUsers, setAllUsers] = useState([])
    const [active, setActive] = useState(false)


    useEffect(() => {
        if (localStorage.getItem('token') && userStore.isAuth) {
            navigate('/job/task')
        }
        fetchUsers().then(data => setAllUsers(data))
    }, [userStore.isAuth])

    const signIn = () => {
        if (allUsers.length === 0) {
            userStore.registr(nickname.toLowerCase(), password, firstName, secondName, 'ADMIN', setActive)
        }
        if (allUsers.length !== 0) {
            userStore.registr(nickname.toLowerCase(), password, firstName, secondName, 'USER', setActive)
        }
    }

    return (
        <div className="screen__block">
            <div className="screen-1">
                <div className="logo__login">
                    <img src={logo} alt={logo}/>
                </div>
                <div className="email">
                    <label htmlFor="email">Ваш логин</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setNickname(e.target.value)} type="text" name="nickname" placeholder="Login"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="password">Пароль</label>
                    <div className="sec-2">
                        <ion-icon name="lock-closed-outline"></ion-icon>
                        <input onChange={e => setPassword(e.target.value)} className="pas" type="password" name="password" placeholder="············"/>
                        <ion-icon className="show-hide" name="eye-outline"></ion-icon>
                    </div>
                    {password.length < 6 && password !== '' ?
                        <h5>Пароль меньше шести символов!</h5>
                        : null
                    }
                </div>
                <div className="password">
                    <label htmlFor="email">Фамилия</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setFirstName(e.target.value)} type="text" name="lastName" placeholder="Фамилия"/>
                    </div>
                </div>
                <div className="password">
                    <label htmlFor="email">Имя</label>
                    <div className="sec-2">
                        <ion-icon name="mail-outline"></ion-icon>
                        <input onChange={e => setSecondName(e.target.value)} type="text" name="secondName" placeholder="Имя"/>
                    </div>
                </div>
                {nickname !== ' ' && password.length > 5 && firstName !== ' ' && secondName !== ' '
                ?
                    <button className="login" onClick={signIn}>Регистрация</button>
                :
                    <button className="login__dis">Заполните все поля</button>
                }

                <div className="footer"><span onClick={() => navigate('/login')}>Войти</span><span></span></div>
            </div>
            <ModalRegistration active={active} setActive={setActive}/>
        </div>
    );
};

export default observer(Registration);